<template>
  <div class="ad-campaign-details">
    <div class="ad-campaign-details-container">
      <div class="ad-campaign-details-h">
        <div class="ad-campaign-details-title">
          <span class="text">{{ $t("Campaigns.FacebookCampaignDetails.Title") }}</span>
        </div>
        <div class="ad-campaign-details-close" @click="emitToggleFacebookCampaignDetails2">
          <icon-base width="16" height="16" view-box="0 0 7 7" icon-name="times"><icon-times /></icon-base>
        </div>
      </div>
      <div v-if="facebookCampaign" class="ad-campaign-details-b">
        <AdPreview
          :ad-group-id="ad.AdGroupIdExternal"
          :ad-id="ad.AdId"
          :channel-id="ad.ChannelId"
          :hide-footer="true"
          :inline="false"
          :show-footer="false"
        />
        <div class="addetails-title">{{ $t("Campaigns.FacebookCampaignDetails.Status") }}</div>
        <div class="campaign-status">
          <div class="campaign-name-status">
            <template v-if="facebookCampaign.status === 'PAUSED'">
              <span class="indicator indicator-4"></span>
            </template>
            <template v-else-if="facebookCampaign.status === 'ACTIVE'">
              <span class="indicator indicator-1"></span>
            </template>
            <template v-else-if="facebookCampaign.status === 'ARCHIVED'">
              <span class="indicator indicator-5"></span>
            </template>
            <template v-else-if="facebookCampaign.status === 'DELETED'">
              <span class="indicator indicator-3"></span>
            </template>
          </div>
          <div class="status-str-text">
            {{ facebookCampaign.status }}
          </div>
        </div>
        <div class="addetails-title">{{ $t("Campaigns.FacebookCampaignDetails.NameOfCampaign") }}</div>
        <div class="addetails-text">{{ facebookCampaign.Name }}</div>

        <b-collapse :open="true" class="card addetails-card" animation="slide">
          <template #trigger="props">
            <div class="card-header" role="button">
              <p class="card-header-title">
                {{ $t("Campaigns.FacebookCampaignDetails.BudgetAndSchedule") }}
              </p>
              <a class="card-header-icon">
                <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"></b-icon>
              </a>
            </div>
          </template>
          <div class="card-content">
            <div class="addetails-subtitle">{{ $t("Campaigns.FacebookCampaignDetails.Budget") }}</div>
            <div class="addetails-text">
              {{ $t("Campaigns.FacebookCampaignDetails.BudgetLifetime") }}
              {{ facebookCampaign.lifetime_budget || adGroup.AdGroupBudget }}₪
            </div>
            <div class="addetails-text">
              {{ $t("Campaigns.FacebookCampaignDetails.BudgetDaily") }}
              {{ facebookCampaign.daily_budget }}₪
            </div>
            <div class="addetails-subtitle">{{ $t("Campaigns.FacebookCampaignDetails.Schedule") }}</div>
            <div class="addetails-text">
              {{ formatDate(facebookCampaign.start_time) }}
            </div>
            <div class="addetails-text">
              {{ formatDate(facebookCampaign.stop_time) }}
            </div>
            <div class="addetails-subtitle">{{ $t("Campaigns.FacebookCampaignDetails.Objective") }}</div>
            <div class="addetails-text">
              {{ facebookCampaign.objective }}
            </div>
          </div>
        </b-collapse>

        <b-collapse :open="true" class="card addetails-card" animation="slide">
          <template #trigger="props">
            <div class="card-header" role="button">
              <p class="card-header-title">
                {{ $t("Campaigns.FacebookCampaignDetails.PostalCode") }}
              </p>
              <a class="card-header-icon">
                <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"></b-icon>
              </a>
            </div>
          </template>
          <div class="card-content">
            <div v-for="targetingProperty in targetingProperties" :key="targetingProperty.Key">
              <div v-if="targetingProperty.Value">
                <div class="addetails-subtitle">{{ targetingProperty.Key }}</div>
                <!-- eslint-disable-next-line vue/no-v-html -->
                <div class="addetails-text" v-html="targetingProperty.Value"></div>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
    <div class="ad-campaign-details-bg" @click="emitToggleFacebookCampaignDetails2"></div>
  </div>
</template>

<script lang="ts">
import moment from "moment";
import { Component, Prop, Vue } from "vue-property-decorator";
import { AdGroupAdStatus } from "@/models/campaigns/AdGroupAdStatus";
import { CampaignAdGridViewModel } from "@/models/campaigns/CampaignAdGridViewModel";
import { CampaignAdGroupGridViewModel } from "@/models/campaigns/CampaignAdGroupGridViewModel";
import { FacebookCampaign } from "@/models/campaigns/FacebookCampaign";
import FacebookApiService from "@/services/api/FacebookApiService";
import AdPreview from "./AdPreview.vue";
import IconBase from "../IconBase.vue";
import IconCaretDown from "../icons/IconCaretDown.vue";
import IconTimes from "../icons/IconTimes.vue";

// const namespace = "campaignsModule";

interface IKeyValuePair {
  Key: string;
  Value: string;
}

@Component({
  components: {
    AdPreview,
    IconBase,
    IconCaretDown,
    IconTimes,
  },
})
export default class FacebookCampaignDetails extends Vue {
  @Prop() readonly adGroup!: CampaignAdGroupGridViewModel;
  @Prop() readonly ad!: CampaignAdGridViewModel;

  emitToggleFacebookCampaignDetails2(): void {
    this.$emit("toggle-facebook-campaign-details2");
  }

  //#region Properties

  facebookCampaign: FacebookCampaign | null = null;

  AdGroupAdStatus = AdGroupAdStatus;

  //#endregion Properties

  //#region Getters

  get targetingProperties(): IKeyValuePair[] {
    return JSON.parse(this.adGroup.AdSetTargetsParsed);
  }

  //#endregion Getters

  //#region Lifecycle

  mounted(): void {
    FacebookApiService.getFacebookCampaign(this.adGroup.AdCampaignId)
      .then((result: FacebookCampaign) => {
        this.facebookCampaign = result;
      })
      .finally(() => {
        // loader.hide();
      });
  }

  //#endregion Lifecycle

  //#region Private methods

  formatDate(date?: Date): string {
    if (!date) {
      return "";
    }
    return moment(date).format("DD/MM/YYYY HH:mm");
  }

  //#endregion Private methods
}
</script>

<style lang="scss">
@import "@/assets/styles/ad-campaign-details";
</style>
